import React from 'react';
import logo from '../../../assets/logos/Logo.svg';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader" aria-hidden="true">
      <img className="loader__logo" src={logo} alt="VBS" width="67" height="32" />
    </div>
  );
};

export default Loader;
